import { EdwardColors } from 'enums';

const v2_vyvoj1 = require('assets/chartExamples/v2_hodnota_1.svg');
const v2_vyvoj2 = require('assets/chartExamples/v2_hodnota_2.svg');
const v2_vyvoj3 = require('assets/chartExamples/v2_hodnota_3.svg');
const v2_vynos1 = require('assets/chartExamples/v2_vynos_1.svg');
const v2_vynos2 = require('assets/chartExamples/v2_vynos_2.svg');
const v2_vynos3 = require('assets/chartExamples/v2_vynos_3.svg');
const company = require('assets/icons/company.svg');
const esg = require('assets/icons/esg.svg');

export interface Extension {
  icon: string;
  activeColor: string;
}

export interface QA {
  type: 'check' | 'radio';
  name: number;
  options: number;
  images?: string[];
  notaIndex?: string;
  condition?: {
    questionIndex: string;
    answerIndex: string;
  };
  stop?: string;
  disabledInPortfolio?: string[];
  valueInTitle?: string;
  extended?: Extension[];
  tooltip?: boolean;
  info?: boolean;
  detailInfo?: string;
  detailDefault?: string;
  currency?: boolean;
  order?: string[];
}

export interface QAs {
  [key: string]: { [key: number]: QA[] };
}

export const structure: QAs = {
  '3': {
    0: [
      { type: 'radio', name: 1, options: 4 },
      { type: 'radio', name: 2, options: 10, stop: '1' },
      { type: 'radio', name: 3, options: 4, valueInTitle: '2' },
      { type: 'radio', name: 4, options: 3, images: [v2_vyvoj1.default, v2_vyvoj2.default, v2_vyvoj3.default] },
      { type: 'radio', name: 5, options: 3, images: [v2_vynos1.default, v2_vynos2.default, v2_vynos3.default] },
    ],
    1: [
      { type: 'radio', name: 6, options: 3 },
      { type: 'radio', name: 7, options: 5, disabledInPortfolio: ['1'], order: ['2','3','4','5','1'] },
      { type: 'radio', name: 8, options: 5, disabledInPortfolio: ['1'], order: ['2','3','4','5','1'] },
      { type: 'radio', name: 9, options: 3 },
    ],
    2: [
      { type: 'radio', name: 10, options: 4 },
      { type: 'radio', name: 11, options: 4 },
      { type: 'radio', name: 12, options: 4 },
      { type: 'radio', name: 13, options: 4 },
      { type: 'check', name: 14, options: 5, notaIndex: '5' },
      { type: 'radio', name: 1411, options: 4, condition: { questionIndex: '14', answerIndex: '1' } },
      { type: 'radio', name: 1421, options: 4, condition: { questionIndex: '14', answerIndex: '2' } },
      { type: 'radio', name: 1431, options: 4, condition: { questionIndex: '14', answerIndex: '3' } },
      { type: 'radio', name: 1441, options: 4, condition: { questionIndex: '14', answerIndex: '4' } },
    ],
    3: [
      { type: 'check', name: 15, options: 4, notaIndex: '1' },
      { type: 'radio', name: 1521, options: 3, condition: { questionIndex: '15', answerIndex: '2' } },
      { type: 'radio', name: 1522, options: 3, condition: { questionIndex: '15', answerIndex: '2' } },
      { type: 'radio', name: 1523, options: 3, condition: { questionIndex: '15', answerIndex: '2' }, currency: true },
      { type: 'radio', name: 1531, options: 3, condition: { questionIndex: '15', answerIndex: '3' } },
      { type: 'radio', name: 1532, options: 3, condition: { questionIndex: '15', answerIndex: '3' } },
      { type: 'radio', name: 1533, options: 3, condition: { questionIndex: '15', answerIndex: '3' }, currency: true },
      { type: 'radio', name: 1541, options: 3, condition: { questionIndex: '15', answerIndex: '4' } },
      { type: 'radio', name: 1542, options: 3, condition: { questionIndex: '15', answerIndex: '4' } },
      { type: 'radio', name: 1543, options: 3, condition: { questionIndex: '15', answerIndex: '4' }, currency: true },
    ],
    4: [
      { type: 'radio', name: 16, options: 5 },
      { type: 'check', name: 17, options: 6 },
      { type: 'radio', name: 18, options: 5, currency: true },
      { type: 'radio', name: 19, options: 6, order: ['6','1','2','3','4','5'] },
      { type: 'radio', name: 20, options: 4, valueInTitle: '2', stop: '1' },
    ],
    5: [
      {
        type: 'radio',
        name: 21,
        options: 3,
        tooltip: true,
        extended: [
          { icon: esg.default, activeColor: EdwardColors.GREEN_LIGHT },
          { icon: esg.default, activeColor: EdwardColors.GREEN_LIGHT },
          { icon: company.default, activeColor: EdwardColors.LIGHT },
        ],
        detailInfo: '1',
        detailDefault: '3',
      },
      { type: 'radio', name: 2121, options: 3, condition: { questionIndex: '21', answerIndex: '2' }, tooltip: true, info: true },
      { type: 'radio', name: 2122, options: 2, condition: { questionIndex: '21', answerIndex: '2' }, tooltip: true, info: true },
      { type: 'check', name: 2123, options: 7, condition: { questionIndex: '21', answerIndex: '2' }, tooltip: true, info: true },
    ],
  },
};
